<template>

  <div class="file">
    <img v-if="type === 'picture' && source" :src="source" @click="click()" />
    <div class="document" v-if="type !== 'picture' || !source" @click="click()">
      <font-awesome-icon :icon="icon"></font-awesome-icon>
    </div>

    <div class="name">{{ name }}</div>
  </div>

</template>

<script>
  export default {
    name: 'file-preview',

    props: [ 'file', 'size' ],

    computed: {
      type () {
        return /png|jpe?g/.test(this.file.extension) ? 'picture' : 'document'
      },

      source () {
        const source = this.$store.state.files[this.file.id]
        return source ? source[this.size] : ''
      },

      icon () {
        const extension = this.file.extension.split('.').pop()

        if ([ 'pdf' ].includes(extension))
          return 'file-pdf'

        if ([ 'doc', 'docx', 'odt', 'rtf' ].includes(extension))
          return 'file-word'

        if ([ 'xls', 'xlsx', 'ods' ].includes(extension))
          return 'file-excel'

        if ([ 'ppt', 'pptx', 'odp' ].includes(extension))
          return 'file-powerpoint'

        if ([ 'zip', 'rar', '7z', 'tar', 'gz' ].includes(extension))
          return 'file-archive'

        if ([ 'txt', 'csv' ].includes(extension))
          return 'file-alt'

        return 'file'
      },

      name () {
        return this.file.path
      }
    },

    methods: {
      click () {
        this.$emit('click', this.file)
      }
    },

    mounted () {
      this.$store.dispatch('getFile', { fileId: this.file.id, requiredSize: this.size })
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  .document {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: $color-dark-gray;
      height: 50px;
      width: auto;
    }
  }

  .name {
    font-size: 10px;
    text-align: center;
  }

</style>
